import { render, staticRenderFns } from "./CashWallet.vue?vue&type=template&id=cee227a6&scoped=true"
import script from "./CashWallet.vue?vue&type=script&lang=js"
export * from "./CashWallet.vue?vue&type=script&lang=js"
import style0 from "./CashWallet.vue?vue&type=style&index=0&id=cee227a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cee227a6",
  null
  
)

export default component.exports